import {createAction} from 'redux-act'

export const setGoalItemModalVisible = createAction('SET_GOAL_ITEM_MODAL_VISIBLE')
export const setGoalItemForm = createAction('SET_GOAL_ITEM_FORM')
export const closeGoalItemForm = createAction('CLOSE_GOAL_ITEM_FORM')


